// Comments module i18n fragment
const fragment = {
  vi: {
    // ===== Comments (list) =====
    'cmt.comments.statusAll': 'Tất cả trạng thái',
    'cmt.comments.statusDraft': 'Nháp',
    'cmt.comments.statusScheduled': 'Đã lên lịch',
    'cmt.comments.statusPublished': 'Đã đăng',
    'cmt.comments.statusFailed': 'Lỗi',
    'cmt.comments.platformAll': 'Tất cả nền tảng',
    'cmt.comments.tabAll': 'Tất cả',
    'cmt.comments.title': 'Comment bài viết',
    'cmt.comments.bulkSchedule': 'Bulk schedule',
    'cmt.comments.createComment': 'Tạo comment',
    'cmt.comments.search': 'Tìm kiếm',
    'cmt.comments.searchPlaceholder': 'Tìm theo nội dung',
    'cmt.comments.platform': 'Nền tảng',
    'cmt.comments.status': 'Trạng thái',
    'cmt.comments.filter': 'Lọc',
    'cmt.comments.reset': 'Đặt lại',

    // ===== StatsCards =====
    'cmt.statsCards.total': 'Tổng',
    'cmt.statsCards.draft': 'Nháp',
    'cmt.statsCards.scheduled': 'Đã lên lịch',
    'cmt.statsCards.published': 'Đã đăng',
    'cmt.statsCards.failed': 'Lỗi',

    // ===== Table =====
    'cmt.table.statusPublished': 'Đã đăng',
    'cmt.table.statusFailed': 'Lỗi',
    'cmt.table.statusScheduled': '📅 Đã lên lịch',
    'cmt.table.statusProcessing': '⏳ Đang đăng',
    'cmt.table.statusDraft': 'Nháp',
    'cmt.table.waitingCron': 'Đang chờ cron xử lý',
    'cmt.table.processing': 'Đang đăng…',
    'cmt.table.selectTimeError': 'Vui lòng chọn thời gian.',
    'cmt.table.leadTimeError': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'cmt.table.changeScheduleTime': 'Đổi giờ đăng',
    'cmt.table.changeScheduleTimeAria': 'Đổi giờ đăng',
    'cmt.table.pickNewDateTime': 'Chọn ngày giờ mới',
    'cmt.table.minLeadHint': 'Cách hiện tại tối thiểu {minutes} phút.',
    'cmt.table.cancel': 'Huỷ',
    'cmt.table.saveSchedule': 'Lưu lịch',
    'cmt.table.deleteTitle': 'Xoá comment?',
    'cmt.table.deleteDesc':
      'Comment sẽ bị xoá khỏi hệ thống. Comment đã đăng trên platform vẫn còn.',
    'cmt.table.deleteConfirm': 'Xoá',
    'cmt.table.deleteSuccess': 'Đã xoá comment.',
    'cmt.table.publishScheduledTitle': 'Đăng ngay comment đã lên lịch?',
    'cmt.table.publishScheduledDesc': 'Lịch đăng tự động sẽ bị huỷ và comment sẽ được đăng ngay.',
    'cmt.table.publishNow': 'Đăng ngay',
    'cmt.table.publishSuccess': 'Đăng comment thành công.',
    'cmt.table.publishFailed': 'Đăng comment thất bại.',
    'cmt.table.retrySuccess': 'Đã thử đăng lại.',
    'cmt.table.retryFailed': 'Thử lại thất bại.',
    'cmt.table.rescheduleSuccess': 'Đã cập nhật lịch đăng.',
    'cmt.table.rescheduleFailed': 'Cập nhật lịch thất bại.',
    'cmt.table.cancelScheduleTitle': 'Huỷ lịch đăng?',
    'cmt.table.cancelScheduleDesc': 'Comment sẽ chuyển về trạng thái Nháp.',
    'cmt.table.cancelScheduleConfirm': 'Huỷ lịch',
    'cmt.table.cancelScheduleSuccess': 'Đã huỷ lịch đăng.',
    'cmt.table.colAccount': 'Tài khoản',
    'cmt.table.colTarget': 'Bài viết',
    'cmt.table.colMessage': 'Nội dung',
    'cmt.table.colStatus': 'Trạng thái',
    'cmt.table.colTime': 'Thời gian',
    'cmt.table.colLink': 'Link comment',
    'cmt.table.colCreatedAt': 'Tạo lúc',
    'cmt.table.colAction': 'Thao tác',
    'cmt.table.copyLink': 'Sao chép link',
    'cmt.table.viewOnPlatform': 'Xem trên platform',
    'cmt.table.viewDetail': 'Xem chi tiết',
    'cmt.table.cancelScheduleTooltip': 'Huỷ lịch đăng',
    'cmt.table.retryTooltip': 'Thử đăng lại',
    'cmt.table.publishNowTooltip': 'Đăng ngay',
    'cmt.table.editTooltip': 'Sửa comment',
    'cmt.table.deleteTooltip': 'Xoá comment',
    'cmt.table.emptyTitle': 'Chưa có comment',
    'cmt.table.emptyDesc': 'Tạo comment đầu tiên cho bài viết Facebook / X / YouTube',

    // ===== CommentDetail =====
    'cmt.commentDetail.statusDraft': 'Nháp',
    'cmt.commentDetail.statusScheduled': '📅 Đã lên lịch',
    'cmt.commentDetail.statusProcessing': '⏳ Đang đăng',
    'cmt.commentDetail.statusPublished': 'Đã đăng',
    'cmt.commentDetail.statusFailed': 'Lỗi',
    'cmt.commentDetail.loading': 'Đang tải...',
    'cmt.commentDetail.publishNowTitle': 'Đăng ngay?',
    'cmt.commentDetail.publishNowDesc': 'Lịch đăng tự động sẽ bị huỷ.',
    'cmt.commentDetail.publishNowConfirm': 'Đăng ngay',
    'cmt.commentDetail.publishSuccess': 'Đăng comment thành công.',
    'cmt.commentDetail.publishFailed': 'Đăng thất bại.',
    'cmt.commentDetail.retrySuccess': 'Đã thử lại.',
    'cmt.commentDetail.retryFailed': 'Thử lại thất bại.',
    'cmt.commentDetail.back': 'Quay lại',
    'cmt.commentDetail.title': 'Chi tiết comment',
    'cmt.commentDetail.edit': 'Sửa',
    'cmt.commentDetail.retry': 'Thử lại',
    'cmt.commentDetail.publishNow': 'Đăng ngay',
    'cmt.commentDetail.errorDetail': 'Chi tiết: {raw}',
    'cmt.commentDetail.account': 'Tài khoản đăng',
    'cmt.commentDetail.targetPost': 'Bài viết được comment',
    'cmt.commentDetail.pageId': 'Page ID: {id}',
    'cmt.commentDetail.openOriginal': 'Mở bài gốc',
    'cmt.commentDetail.content': 'Nội dung comment',
    'cmt.commentDetail.rowStatus': 'Trạng thái',
    'cmt.commentDetail.rowScheduledAt': 'Thời điểm lên lịch',
    'cmt.commentDetail.rowPublishedAt': 'Đã đăng lúc',
    'cmt.commentDetail.rowLastAttempt': 'Lần thử cuối',
    'cmt.commentDetail.rowRetryCount': 'Số lần thử',
    'cmt.commentDetail.rowPermalink': 'Link comment trên platform',
    'cmt.commentDetail.copy': 'Sao chép',
    'cmt.commentDetail.rowCommentId': 'Comment ID',
    'cmt.commentDetail.rowCreatedAt': 'Tạo lúc',
    'cmt.commentDetail.rowUpdatedAt': 'Cập nhật cuối',

    // ===== CommentForm =====
    'cmt.commentForm.platformFacebookHint': 'Comment vào bài đăng trên Fanpage bạn admin.',
    'cmt.commentForm.platformXHint': 'Reply 1 tweet bất kỳ. Free tier giới hạn 17 reply/24h.',
    'cmt.commentForm.platformYoutubeHint':
      'Comment vào video. Quota 50 units/comment, mặc định 10k/ngày.',
    'cmt.commentForm.step1Title': 'Tài khoản',
    'cmt.commentForm.step1Desc': 'Chọn nền tảng & acc',
    'cmt.commentForm.step2Title': 'Bài viết',
    'cmt.commentForm.step2Desc': 'Dán URL bài cần comment',
    'cmt.commentForm.step3Title': 'Nội dung',
    'cmt.commentForm.step3Desc': 'Soạn comment & đăng',
    'cmt.commentForm.statusPublished': 'Đã đăng',
    'cmt.commentForm.statusFailed': 'Lỗi',
    'cmt.commentForm.statusScheduled': 'Đã lên lịch',
    'cmt.commentForm.statusProcessing': 'Đang đăng',
    'cmt.commentForm.statusDraft': 'Nháp',
    'cmt.commentForm.template': 'Template ({count})',
    'cmt.commentForm.noTemplate': 'Chưa có template nào',
    'cmt.commentForm.manageTemplates': '+ Quản lý templates',
    'cmt.commentForm.loadingPreview': 'Đang lấy preview...',
    'cmt.commentForm.pasteUrlHint': 'Dán URL bài viết để xem preview tại đây',
    'cmt.commentForm.postRecognized': 'Đã nhận diện bài viết',
    'cmt.commentForm.open': 'Mở',
    'cmt.commentForm.backAria': 'Quay lại',
    'cmt.commentForm.editTitle': 'Sửa comment',
    'cmt.commentForm.createTitle': 'Tạo comment mới',
    'cmt.commentForm.step1Lead': 'Bước 1/3:',
    'cmt.commentForm.step1LeadText': 'Chọn nền tảng và tài khoản dùng để comment.',
    'cmt.commentForm.platform': 'Nền tảng',
    'cmt.commentForm.account': 'Tài khoản',
    'cmt.commentForm.selectAccount': 'Chọn tài khoản',
    'cmt.commentForm.selectPlatformFirst': 'Hãy chọn nền tảng trước',
    'cmt.commentForm.noActiveAccountPre': 'Chưa có tài khoản {platform} nào active. Vào',
    'cmt.commentForm.accountManagePage': 'trang quản lý tài khoản',
    'cmt.commentForm.noActiveAccountPost': 'để kết nối.',
    'cmt.commentForm.step2Lead': 'Bước 2/3:',
    'cmt.commentForm.step2LeadText': 'Dán URL bài viết bạn muốn comment. Hệ thống tự nhận diện ID.',
    'cmt.commentForm.postUrl': 'URL bài viết',
    'cmt.commentForm.selectPlatformStep1': 'Hãy chọn nền tảng ở bước 1',
    'cmt.commentForm.analyzingUrl': '⏳ Đang phân tích URL...',
    'cmt.commentForm.autoDetectHint': 'Hệ thống sẽ tự nhận diện ID khi bạn paste URL.',
    'cmt.commentForm.manualIdHint': 'Nhập ID thủ công (nếu URL không nhận diện được)',
    'cmt.commentForm.postId': 'ID bài viết',
    'cmt.commentForm.pageId': 'Page ID',
    'cmt.commentForm.fanpageIdPlaceholder': 'Fanpage ID',
    'cmt.commentForm.manualPreviewTooltip': 'Lấy preview thủ công',
    'cmt.commentForm.manualPreviewAria': 'Preview thủ công',
    'cmt.commentForm.step3Lead': 'Bước 3/3:',
    'cmt.commentForm.step3LeadText': 'Soạn nội dung và chọn cách đăng.',
    'cmt.commentForm.summaryPre': 'Comment dưới tên',
    'cmt.commentForm.summaryMid': 'vào bài',
    'cmt.commentForm.contentLabel': 'Nội dung comment',
    'cmt.commentForm.contentPlaceholder': 'Nhập nội dung comment...',
    'cmt.commentForm.postMode': 'Cách đăng',
    'cmt.commentForm.modeDraft': '📝 Lưu nháp',
    'cmt.commentForm.modeSchedule': '📅 Lên lịch',
    'cmt.commentForm.modePublish': '🚀 Đăng ngay',
    'cmt.commentForm.scheduleTime': 'Thời điểm đăng',
    'cmt.commentForm.scheduleDatePlaceholder': 'Chọn ngày giờ đăng',
    'cmt.commentForm.scheduleHint':
      'Cách hiện tại tối thiểu {minutes} phút. Cron chạy mỗi phút sẽ tự đăng.',
    'cmt.commentForm.fbNoteTitle': 'Lưu ý Facebook',
    'cmt.commentForm.fbNoteDescPre': 'Cần permission',
    'cmt.commentForm.fbNoteDescPost': 'và bạn phải là admin/editor của Fanpage.',
    'cmt.commentForm.cancel': 'Huỷ',
    'cmt.commentForm.backStep': '← Quay lại',
    'cmt.commentForm.next': 'Tiếp theo →',
    'cmt.commentForm.saveChanges': 'Lưu thay đổi',
    'cmt.commentForm.submitPublish': '🚀 Đăng ngay',
    'cmt.commentForm.submitSchedule': '📅 Lên lịch',
    'cmt.commentForm.submitDraft': '📝 Lưu nháp',
    'cmt.commentForm.errSelectPlatform': 'Hãy chọn nền tảng.',
    'cmt.commentForm.errSelectAccount': 'Hãy chọn tài khoản.',
    'cmt.commentForm.errNoPost': 'Chưa nhận diện được bài viết.',
    'cmt.commentForm.errNeedPageId': 'FB cần Page ID.',
    'cmt.commentForm.errNeedMessage': 'Hãy nhập nội dung comment.',
    'cmt.commentForm.errTooLong': 'Nội dung vượt quá {limit} ký tự.',
    'cmt.commentForm.errSelectScheduleTime': 'Hãy chọn thời gian lên lịch.',
    'cmt.commentForm.errLeadTime': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'cmt.commentForm.updateSuccess': 'Đã cập nhật comment.',
    'cmt.commentForm.updateFailed': 'Cập nhật thất bại.',
    'cmt.commentForm.publishSuccess': 'Đăng comment thành công.',
    'cmt.commentForm.scheduleSuccess': 'Đã lên lịch comment.',
    'cmt.commentForm.draftSuccess': 'Đã lưu nháp.',
    'cmt.commentForm.createFailed': 'Tạo comment thất bại.',
    'cmt.commentForm.completeStep': 'Hãy hoàn thành bước hiện tại.',

    // ===== Errors (errorTranslator) =====
    'cmt.errors.fbTokenExpiredTitle': 'Token Facebook đã hết hạn',
    'cmt.errors.fbTokenExpiredSuggestion': 'Vào Tài khoản Facebook → ngắt kết nối và kết nối lại.',
    'cmt.errors.fbNoPermissionTitle': 'App Facebook chưa có quyền comment',
    'cmt.errors.fbNoPermissionSuggestion':
      'App cần permission "pages_manage_engagement". Vào Meta Developers → App Review → Permissions để bật.',
    'cmt.errors.fbPageRoleTitle': 'Không đủ quyền với Page',
    'cmt.errors.fbPageRoleSuggestion':
      'Bạn có phải admin/editor của Page này không? Vào Meta Business → Setting → Pages để kiểm tra role.',
    'cmt.errors.fbInvalidIdTitle': 'ID bài viết không hợp lệ',
    'cmt.errors.fbInvalidIdSuggestion':
      'Bài có thể đã bị xoá / hidden. Hãy mở URL gốc trên Facebook để xác nhận.',
    'cmt.errors.fbBlockedTitle': 'Bị Facebook chặn tạm thời',
    'cmt.errors.fbBlockedSuggestion':
      'Đang comment quá nhanh. Đợi 1–2 giờ và giảm tần suất hoặc đổi nội dung.',
    'cmt.errors.fbPageTokenTitle': 'Không lấy được Page token',
    'cmt.errors.fbPageTokenSuggestion':
      'User Facebook đã connect không phải admin Page này. Hãy connect đúng acc admin.',
    'cmt.errors.xTokenExpiredTitle': 'Token X đã hết hạn',
    'cmt.errors.xTokenExpiredSuggestion': 'Vào Tài khoản X → ngắt kết nối và kết nối lại.',
    'cmt.errors.xCannotReplyTitle': 'Không thể reply tweet này',
    'cmt.errors.xCannotReplySuggestion':
      'Tweet có thể đã bị khoá reply, hoặc account của bạn bị block bởi người đăng.',
    'cmt.errors.xRateLimitTitle': 'Vượt giới hạn X API',
    'cmt.errors.xRateLimitSuggestion':
      'X Free tier chỉ 17 writes/24h. Đợi reset hoặc nâng cấp lên Basic tier.',
    'cmt.errors.xDuplicateTitle': 'Nội dung trùng tweet cũ',
    'cmt.errors.xDuplicateSuggestion': 'X chặn post trùng. Hãy sửa nội dung cho khác đi.',
    'cmt.errors.ytCommentsDisabledTitle': 'Video đã tắt comment',
    'cmt.errors.ytCommentsDisabledSuggestion':
      'Chủ kênh đã tắt comment cho video này. Không thể comment được.',
    'cmt.errors.ytQuotaTitle': 'Hết quota YouTube API hôm nay',
    'cmt.errors.ytQuotaSuggestion':
      'Quota mặc định 10k units/ngày. Reset lúc 0h Pacific time. Hoặc request tăng quota.',
    'cmt.errors.ytPermissionTitle': 'Token YouTube không đủ quyền',
    'cmt.errors.ytPermissionSuggestion':
      'Cần scope youtube.force-ssl. Vào Tài khoản YouTube → ngắt kết nối và kết nối lại.',
    'cmt.errors.ytVideoNotFoundTitle': 'Không tìm thấy video',
    'cmt.errors.ytVideoNotFoundSuggestion': 'Video có thể đã bị xoá, private, hoặc videoId sai.',
    'cmt.errors.genericTitle': 'Có lỗi xảy ra',
    'cmt.errors.genericSuggestion': 'Hãy thử lại. Nếu vẫn lỗi, gửi log cho team dev.',
  },
  en: {
    // ===== Comments (list) =====
    'cmt.comments.statusAll': 'All statuses',
    'cmt.comments.statusDraft': 'Draft',
    'cmt.comments.statusScheduled': 'Scheduled',
    'cmt.comments.statusPublished': 'Published',
    'cmt.comments.statusFailed': 'Failed',
    'cmt.comments.platformAll': 'All platforms',
    'cmt.comments.tabAll': 'All',
    'cmt.comments.title': 'Post comments',
    'cmt.comments.bulkSchedule': 'Bulk schedule',
    'cmt.comments.createComment': 'Create comment',
    'cmt.comments.search': 'Search',
    'cmt.comments.searchPlaceholder': 'Search by content',
    'cmt.comments.platform': 'Platform',
    'cmt.comments.status': 'Status',
    'cmt.comments.filter': 'Filter',
    'cmt.comments.reset': 'Reset',

    // ===== StatsCards =====
    'cmt.statsCards.total': 'Total',
    'cmt.statsCards.draft': 'Draft',
    'cmt.statsCards.scheduled': 'Scheduled',
    'cmt.statsCards.published': 'Published',
    'cmt.statsCards.failed': 'Failed',

    // ===== Table =====
    'cmt.table.statusPublished': 'Published',
    'cmt.table.statusFailed': 'Failed',
    'cmt.table.statusScheduled': '📅 Scheduled',
    'cmt.table.statusProcessing': '⏳ Posting',
    'cmt.table.statusDraft': 'Draft',
    'cmt.table.waitingCron': 'Waiting for cron',
    'cmt.table.processing': 'Posting…',
    'cmt.table.selectTimeError': 'Please select a time.',
    'cmt.table.leadTimeError': 'Posting time must be at least {minutes} minutes from now.',
    'cmt.table.changeScheduleTime': 'Change posting time',
    'cmt.table.changeScheduleTimeAria': 'Change posting time',
    'cmt.table.pickNewDateTime': 'Pick a new date & time',
    'cmt.table.minLeadHint': 'At least {minutes} minutes from now.',
    'cmt.table.cancel': 'Cancel',
    'cmt.table.saveSchedule': 'Save schedule',
    'cmt.table.deleteTitle': 'Delete comment?',
    'cmt.table.deleteDesc':
      'The comment will be removed from the system. Comments already posted on the platform remain.',
    'cmt.table.deleteConfirm': 'Delete',
    'cmt.table.deleteSuccess': 'Comment deleted.',
    'cmt.table.publishScheduledTitle': 'Publish scheduled comment now?',
    'cmt.table.publishScheduledDesc':
      'The automatic schedule will be cancelled and the comment posted immediately.',
    'cmt.table.publishNow': 'Publish now',
    'cmt.table.publishSuccess': 'Comment published successfully.',
    'cmt.table.publishFailed': 'Failed to publish comment.',
    'cmt.table.retrySuccess': 'Retried posting.',
    'cmt.table.retryFailed': 'Retry failed.',
    'cmt.table.rescheduleSuccess': 'Posting schedule updated.',
    'cmt.table.rescheduleFailed': 'Failed to update schedule.',
    'cmt.table.cancelScheduleTitle': 'Cancel schedule?',
    'cmt.table.cancelScheduleDesc': 'The comment will revert to Draft status.',
    'cmt.table.cancelScheduleConfirm': 'Cancel schedule',
    'cmt.table.cancelScheduleSuccess': 'Schedule cancelled.',
    'cmt.table.colAccount': 'Account',
    'cmt.table.colTarget': 'Post',
    'cmt.table.colMessage': 'Content',
    'cmt.table.colStatus': 'Status',
    'cmt.table.colTime': 'Time',
    'cmt.table.colLink': 'Comment link',
    'cmt.table.colCreatedAt': 'Created at',
    'cmt.table.colAction': 'Actions',
    'cmt.table.copyLink': 'Copy link',
    'cmt.table.viewOnPlatform': 'View on platform',
    'cmt.table.viewDetail': 'View details',
    'cmt.table.cancelScheduleTooltip': 'Cancel schedule',
    'cmt.table.retryTooltip': 'Retry posting',
    'cmt.table.publishNowTooltip': 'Publish now',
    'cmt.table.editTooltip': 'Edit comment',
    'cmt.table.deleteTooltip': 'Delete comment',
    'cmt.table.emptyTitle': 'No comments yet',
    'cmt.table.emptyDesc': 'Create your first comment for a Facebook / X / YouTube post',

    // ===== CommentDetail =====
    'cmt.commentDetail.statusDraft': 'Draft',
    'cmt.commentDetail.statusScheduled': '📅 Scheduled',
    'cmt.commentDetail.statusProcessing': '⏳ Posting',
    'cmt.commentDetail.statusPublished': 'Published',
    'cmt.commentDetail.statusFailed': 'Failed',
    'cmt.commentDetail.loading': 'Loading...',
    'cmt.commentDetail.publishNowTitle': 'Publish now?',
    'cmt.commentDetail.publishNowDesc': 'The automatic schedule will be cancelled.',
    'cmt.commentDetail.publishNowConfirm': 'Publish now',
    'cmt.commentDetail.publishSuccess': 'Comment published successfully.',
    'cmt.commentDetail.publishFailed': 'Publish failed.',
    'cmt.commentDetail.retrySuccess': 'Retried.',
    'cmt.commentDetail.retryFailed': 'Retry failed.',
    'cmt.commentDetail.back': 'Back',
    'cmt.commentDetail.title': 'Comment details',
    'cmt.commentDetail.edit': 'Edit',
    'cmt.commentDetail.retry': 'Retry',
    'cmt.commentDetail.publishNow': 'Publish now',
    'cmt.commentDetail.errorDetail': 'Details: {raw}',
    'cmt.commentDetail.account': 'Posting account',
    'cmt.commentDetail.targetPost': 'Commented post',
    'cmt.commentDetail.pageId': 'Page ID: {id}',
    'cmt.commentDetail.openOriginal': 'Open original post',
    'cmt.commentDetail.content': 'Comment content',
    'cmt.commentDetail.rowStatus': 'Status',
    'cmt.commentDetail.rowScheduledAt': 'Scheduled time',
    'cmt.commentDetail.rowPublishedAt': 'Published at',
    'cmt.commentDetail.rowLastAttempt': 'Last attempt',
    'cmt.commentDetail.rowRetryCount': 'Retry count',
    'cmt.commentDetail.rowPermalink': 'Comment link on platform',
    'cmt.commentDetail.copy': 'Copy',
    'cmt.commentDetail.rowCommentId': 'Comment ID',
    'cmt.commentDetail.rowCreatedAt': 'Created at',
    'cmt.commentDetail.rowUpdatedAt': 'Last updated',

    // ===== CommentForm =====
    'cmt.commentForm.platformFacebookHint': 'Comment on a post on a Fanpage you admin.',
    'cmt.commentForm.platformXHint': 'Reply to any tweet. Free tier is limited to 17 replies/24h.',
    'cmt.commentForm.platformYoutubeHint':
      'Comment on a video. Quota 50 units/comment, default 10k/day.',
    'cmt.commentForm.step1Title': 'Account',
    'cmt.commentForm.step1Desc': 'Choose platform & account',
    'cmt.commentForm.step2Title': 'Post',
    'cmt.commentForm.step2Desc': 'Paste the post URL to comment',
    'cmt.commentForm.step3Title': 'Content',
    'cmt.commentForm.step3Desc': 'Write comment & publish',
    'cmt.commentForm.statusPublished': 'Published',
    'cmt.commentForm.statusFailed': 'Failed',
    'cmt.commentForm.statusScheduled': 'Scheduled',
    'cmt.commentForm.statusProcessing': 'Posting',
    'cmt.commentForm.statusDraft': 'Draft',
    'cmt.commentForm.template': 'Template ({count})',
    'cmt.commentForm.noTemplate': 'No templates yet',
    'cmt.commentForm.manageTemplates': '+ Manage templates',
    'cmt.commentForm.loadingPreview': 'Loading preview...',
    'cmt.commentForm.pasteUrlHint': 'Paste a post URL to see the preview here',
    'cmt.commentForm.postRecognized': 'Post recognized',
    'cmt.commentForm.open': 'Open',
    'cmt.commentForm.backAria': 'Back',
    'cmt.commentForm.editTitle': 'Edit comment',
    'cmt.commentForm.createTitle': 'Create new comment',
    'cmt.commentForm.step1Lead': 'Step 1/3:',
    'cmt.commentForm.step1LeadText': 'Choose the platform and account to comment with.',
    'cmt.commentForm.platform': 'Platform',
    'cmt.commentForm.account': 'Account',
    'cmt.commentForm.selectAccount': 'Select account',
    'cmt.commentForm.selectPlatformFirst': 'Please select a platform first',
    'cmt.commentForm.noActiveAccountPre': 'No active {platform} account. Go to',
    'cmt.commentForm.accountManagePage': 'the account management page',
    'cmt.commentForm.noActiveAccountPost': 'to connect.',
    'cmt.commentForm.step2Lead': 'Step 2/3:',
    'cmt.commentForm.step2LeadText':
      'Paste the URL of the post you want to comment on. The system auto-detects the ID.',
    'cmt.commentForm.postUrl': 'Post URL',
    'cmt.commentForm.selectPlatformStep1': 'Please select a platform in step 1',
    'cmt.commentForm.analyzingUrl': '⏳ Analyzing URL...',
    'cmt.commentForm.autoDetectHint': 'The system auto-detects the ID when you paste a URL.',
    'cmt.commentForm.manualIdHint': 'Enter ID manually (if the URL is not recognized)',
    'cmt.commentForm.postId': 'Post ID',
    'cmt.commentForm.pageId': 'Page ID',
    'cmt.commentForm.fanpageIdPlaceholder': 'Fanpage ID',
    'cmt.commentForm.manualPreviewTooltip': 'Fetch preview manually',
    'cmt.commentForm.manualPreviewAria': 'Manual preview',
    'cmt.commentForm.step3Lead': 'Step 3/3:',
    'cmt.commentForm.step3LeadText': 'Write the content and choose how to publish.',
    'cmt.commentForm.summaryPre': 'Commenting as',
    'cmt.commentForm.summaryMid': 'on post',
    'cmt.commentForm.contentLabel': 'Comment content',
    'cmt.commentForm.contentPlaceholder': 'Enter comment content...',
    'cmt.commentForm.postMode': 'Publish mode',
    'cmt.commentForm.modeDraft': '📝 Save draft',
    'cmt.commentForm.modeSchedule': '📅 Schedule',
    'cmt.commentForm.modePublish': '🚀 Publish now',
    'cmt.commentForm.scheduleTime': 'Posting time',
    'cmt.commentForm.scheduleDatePlaceholder': 'Pick posting date & time',
    'cmt.commentForm.scheduleHint':
      'At least {minutes} minutes from now. The cron runs every minute and posts automatically.',
    'cmt.commentForm.fbNoteTitle': 'Facebook note',
    'cmt.commentForm.fbNoteDescPre': 'Requires permission',
    'cmt.commentForm.fbNoteDescPost': 'and you must be an admin/editor of the Fanpage.',
    'cmt.commentForm.cancel': 'Cancel',
    'cmt.commentForm.backStep': '← Back',
    'cmt.commentForm.next': 'Next →',
    'cmt.commentForm.saveChanges': 'Save changes',
    'cmt.commentForm.submitPublish': '🚀 Publish now',
    'cmt.commentForm.submitSchedule': '📅 Schedule',
    'cmt.commentForm.submitDraft': '📝 Save draft',
    'cmt.commentForm.errSelectPlatform': 'Please select a platform.',
    'cmt.commentForm.errSelectAccount': 'Please select an account.',
    'cmt.commentForm.errNoPost': 'Post not recognized yet.',
    'cmt.commentForm.errNeedPageId': 'Facebook requires a Page ID.',
    'cmt.commentForm.errNeedMessage': 'Please enter comment content.',
    'cmt.commentForm.errTooLong': 'Content exceeds {limit} characters.',
    'cmt.commentForm.errSelectScheduleTime': 'Please select a schedule time.',
    'cmt.commentForm.errLeadTime': 'Posting time must be at least {minutes} minutes from now.',
    'cmt.commentForm.updateSuccess': 'Comment updated.',
    'cmt.commentForm.updateFailed': 'Update failed.',
    'cmt.commentForm.publishSuccess': 'Comment published successfully.',
    'cmt.commentForm.scheduleSuccess': 'Comment scheduled.',
    'cmt.commentForm.draftSuccess': 'Draft saved.',
    'cmt.commentForm.createFailed': 'Failed to create comment.',
    'cmt.commentForm.completeStep': 'Please complete the current step.',

    // ===== Errors (errorTranslator) =====
    'cmt.errors.fbTokenExpiredTitle': 'Facebook token expired',
    'cmt.errors.fbTokenExpiredSuggestion': 'Go to Facebook Accounts → disconnect and reconnect.',
    'cmt.errors.fbNoPermissionTitle': 'Facebook app lacks comment permission',
    'cmt.errors.fbNoPermissionSuggestion':
      'The app needs the "pages_manage_engagement" permission. Go to Meta Developers → App Review → Permissions to enable it.',
    'cmt.errors.fbPageRoleTitle': 'Insufficient permission on Page',
    'cmt.errors.fbPageRoleSuggestion':
      'Are you an admin/editor of this Page? Go to Meta Business → Settings → Pages to check your role.',
    'cmt.errors.fbInvalidIdTitle': 'Invalid post ID',
    'cmt.errors.fbInvalidIdSuggestion':
      'The post may have been deleted/hidden. Open the original URL on Facebook to confirm.',
    'cmt.errors.fbBlockedTitle': 'Temporarily blocked by Facebook',
    'cmt.errors.fbBlockedSuggestion':
      'Commenting too fast. Wait 1–2 hours and reduce the rate or change the content.',
    'cmt.errors.fbPageTokenTitle': 'Could not get Page token',
    'cmt.errors.fbPageTokenSuggestion':
      'The connected Facebook user is not an admin of this Page. Connect the correct admin account.',
    'cmt.errors.xTokenExpiredTitle': 'X token expired',
    'cmt.errors.xTokenExpiredSuggestion': 'Go to X Accounts → disconnect and reconnect.',
    'cmt.errors.xCannotReplyTitle': 'Cannot reply to this tweet',
    'cmt.errors.xCannotReplySuggestion':
      'The tweet may have replies locked, or your account is blocked by the author.',
    'cmt.errors.xRateLimitTitle': 'X API limit exceeded',
    'cmt.errors.xRateLimitSuggestion':
      'X Free tier allows only 17 writes/24h. Wait for reset or upgrade to Basic tier.',
    'cmt.errors.xDuplicateTitle': 'Content duplicates an old tweet',
    'cmt.errors.xDuplicateSuggestion':
      'X blocks duplicate posts. Edit the content to make it different.',
    'cmt.errors.ytCommentsDisabledTitle': 'Comments disabled on video',
    'cmt.errors.ytCommentsDisabledSuggestion':
      'The channel owner disabled comments for this video. Commenting is not possible.',
    'cmt.errors.ytQuotaTitle': 'YouTube API quota exhausted today',
    'cmt.errors.ytQuotaSuggestion':
      'Default quota is 10k units/day. Resets at 0:00 Pacific time. Or request a quota increase.',
    'cmt.errors.ytPermissionTitle': 'YouTube token lacks permission',
    'cmt.errors.ytPermissionSuggestion':
      'Requires the youtube.force-ssl scope. Go to YouTube Accounts → disconnect and reconnect.',
    'cmt.errors.ytVideoNotFoundTitle': 'Video not found',
    'cmt.errors.ytVideoNotFoundSuggestion':
      'The video may be deleted, private, or the videoId is wrong.',
    'cmt.errors.genericTitle': 'An error occurred',
    'cmt.errors.genericSuggestion':
      'Please try again. If it persists, send the log to the dev team.',
  },
};

export default fragment;
